import { TypographyH2 } from '@talentmesh/ui/components/typography';
import UIStrings from '@/Utils/UIStrings';

const RequestInformationStepHeader = () => {
    return (
        <header className="py-6">
            <div className="mx-auto flex max-w-2xl flex-col items-center gap-3 text-center">
                <TypographyH2 className="text-foreground tracking-tight text-balance">
                    {UIStrings.RequestAdditionalApplicantInformation}
                </TypographyH2>
                <p className="text-base leading-relaxed text-balance">{UIStrings.QuickSummaryRequestInformationStep}</p>
            </div>
        </header>
    );
};
export default RequestInformationStepHeader;
